import {IIncident} from "../../../core/interfaces/incident";
import When from "../../../components/When";
import FormProvider from "./FormProvider/FormProvider";

export function CreatedByForm(props: { currentUserName: string, newIncident: IIncident, isNewIncident: boolean }) {
    return <FormProvider controlId={'formReportedBy'} title={'Inrapporterat av'}>
            <span data-test-id='formReportedBy' className={'col-form-label'}>
                <When condition={props.isNewIncident}
                      otherwise={props.newIncident?.createdBy?.name ?? 'Okänd användare'}>
                    {props.currentUserName ?? 'Okänd användare'}
                </When>
            </span>
    </FormProvider>;
}